import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useQuery } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';
import gql from '@zenbusiness/application-commons-utils/gql';

export const GET_ORDER_TASK_STATUS = gql`
  query orderTasksByBusinessEntity($businessEntityUuid: UUID!) {
    orderTasksByBusinessEntity(businessEntityUuid: $businessEntityUuid) {
      type
      status
      jurisdictionCode
      data {
        ... on OrderTaskDataLlcFormation {
          estimatedFormationDate
        }
        ... on OrderTaskDataDefault {
          service
        }
        ... on OrderTaskDataPlan {
          plan
          level
          jurisdiction
        }
      }
    }
  }
`;

function useOrderTrackerStatus() {
  const { businessEntityUuid } = useBusinessEntity();

  const { loading, data, errors } = useQuery(GET_ORDER_TASK_STATUS, {
    noThrow: true,
    variables: {
      businessEntityUuid
    }
  });
  useError(errors);

  return {
    loading,
    orderTasksWithStatus: data?.orderTasksByBusinessEntity || []
  };
}

export { useOrderTrackerStatus };
